export class StatusesTask {
	name: string;
	bgName: string;
}